import {observer} from "mobx-react";
import {ScrollTable} from "../../components/ui";
import {convertDocumentType, mapDocumentTypeStatus} from "../../api";
import {ReactNode} from "react";
import {createKeyedStoreContext} from "./createKeyedStoreContext";
import {VehicleDocumentsStore} from "../store/VehicleDocumentsStore";
import "./Widget.scss"
import {useNavigate} from "react-router";


interface VehicleDocumentsProviderProps {
    customerId: string | undefined
    vin: string | undefined
    children: ReactNode
}

const {
    Provider: BaseVehicleDocumentsProvider,
    useStore: useVehicleDocumentsStore
} = createKeyedStoreContext<VehicleDocumentsStore, VehicleDocumentsProviderProps>({
    displayName: "VehicleDocuments",
    getKey: ({customerId, vin}) => {
        return customerId && vin ?
            `${customerId ?? ""}::${vin ?? ""}` :
            'invalid'
    },
    createStore: ({customerId, vin}) => {
        return customerId && vin ? new VehicleDocumentsStore(customerId, vin) : new VehicleDocumentsStore(undefined, undefined)
    }
})

const VehicleDocumentsProvider = observer(BaseVehicleDocumentsProvider)

interface VehicleDocumentsProps {
    customerId: string | undefined
    vin: string | undefined
}

const WidgetHeader = observer(function WidgetHeader() {
    const store = useVehicleDocumentsStore()
    const navigate = useNavigate()
    return <div className={'card-header'}>
        <span className={'card-header-title'}>Dokumente</span>
        {store.loading && <span className={'card-header-icon'}>
            <button className={'button is-ghost is-loading'}></button>
        </span>}
        {!store.loading && <button className={'card-header-icon'} onClick={() => {
            if (store.vin && store.customerId) {
                navigate(`/vhs/${store.customerId}/${store.vin}`)
            }
        }}>
            <span className="material-symbols-outlined">deployed_code_history</span>
        </button>}
    </div>
})

const WidgetContent = observer(function WidgetContent() {
    const store = useVehicleDocumentsStore()
    const isConfigured = Boolean(store.vin && store.customerId)
    const hasElements = Boolean(store.data.length)

    return <>
        {(!isConfigured || !hasElements) && <div className={'card-content'} style={{display: 'flex', minHeight: '6em'}}>
            {!isConfigured && <>Warte auf FIN und Kunden</>}
            {isConfigured && !hasElements && !store.loading && <div>
                Keine Dokumente für {store.vin} gefunden
            </div>}

        </div>}
        {isConfigured && hasElements && <div className={'card-content'} style={{display: 'flex', padding: '0', height: '6em'}}>
            <ScrollTable>
                <tbody>
                {store.data?.map(e => (
                    <tr key={e.documentId}>
                        <td style={{width: '7em'}}>{convertDocumentType(e.type)}</td>
                        <td>
                            <span className={`tag ${e.status === 'STORED' ? 'is-success' : (e.status === 'RELEASE_PREPARED' ? 'is-warning' : 'is-danger')} is-rounded`} style={{
                                marginLeft: '1em',
                                marginRight: '1em'
                            }}>{mapDocumentTypeStatus(e.status)}</span>
                        </td>
                        <td>{e.location}</td>
                    </tr>
                ))}
                </tbody>
            </ScrollTable>
        </div>}
    </>
})

const VehicleDocumentsWidget = observer(function VehicleDocumentsWidget({
                                                                            customerId,
                                                                            vin
                                                                        }: VehicleDocumentsProps) {

    return <VehicleDocumentsProvider customerId={customerId} vin={vin}>
        <div className={'card widget'}>
            <WidgetHeader/>
            <WidgetContent/>
        </div>
    </VehicleDocumentsProvider>
});

export {
    VehicleDocumentsWidget
}
